import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { colors, fonts } from "../theme";
import { View, Text, Button, ScreenHeader } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { useAuth } from "../auth";

export default function Login() {
  const navigate = useNavigate();
  const { tr, lang, setLang } = useI18n();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/home", { replace: true });
    } catch (e) {
      setError(e?.message || tr("loginFailed"));
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    backgroundColor: colors.surfaceSecondary, border: `1px solid ${colors.border}`, borderRadius: 14,
    padding: "0 16px", height: 54, fontWeight: fonts.medium, fontSize: 16, color: colors.onSurface, width: "100%",
  };

  const langToggle = (
    <View row style={{ backgroundColor: colors.surfaceSecondary, borderRadius: 999, padding: 3 }}>
      {["de", "en"].map((l) => (
        <div key={l} data-testid={`login-lang-${l}`} onClick={() => setLang(l)} style={{
          padding: "5px 12px", borderRadius: 999, cursor: "pointer", backgroundColor: lang === l ? colors.brandPrimary : "transparent",
        }}>
          <span style={{ fontWeight: fonts.bold, fontSize: 12, color: lang === l ? colors.onBrandPrimary : colors.muted }}>{l.toUpperCase()}</span>
        </div>
      ))}
    </View>
  );

  return (
    <View style={{ flex: 1, minHeight: "100vh", backgroundColor: colors.surface }}>
      <ScreenHeader title={tr("signIn")} onBack={() => navigate(-1)} right={langToggle} />
      <View style={{ padding: 20, flex: 1 }}>
        <View style={{ alignItems: "center", margin: "24px 0" }}>
          <View style={{ width: 76, height: 76, borderRadius: 24, backgroundColor: colors.brandTertiary, alignItems: "center", justifyContent: "center" }}>
            <Icon name="cap" size={40} color={colors.brandPrimary} weight="fill" />
          </View>
          <Text style={{ fontWeight: fonts.bold, fontSize: 22, marginTop: 16, color: colors.onSurface }}>MELLY Leadership</Text>
          <Text style={{ fontWeight: fonts.regular, fontSize: 14, color: colors.muted, marginTop: 4 }}>{tr("loginHint")}</Text>
        </View>

        <Text style={{ fontWeight: fonts.semibold, fontSize: 13, color: colors.muted, marginBottom: 8 }}>{tr("email")}</Text>
        <input data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} autoCapitalize="none" type="email" autoComplete="email" placeholder="melly@melly.app" style={inputStyle} />

        <Text style={{ fontWeight: fonts.semibold, fontSize: 13, color: colors.muted, marginBottom: 8, marginTop: 18 }}>{tr("password")}</Text>
        <input data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="••••••••"
          onKeyDown={(e) => { if (e.key === "Enter") submit(); }} style={inputStyle} />

        {error ? (
          <View row data-testid="login-error" style={{ alignItems: "center", gap: 8, backgroundColor: colors.errorSurface, borderRadius: 12, padding: 12, marginTop: 18 }}>
            <Icon name="warning" size={18} color={colors.error} weight="fill" />
            <Text style={{ flex: 1, fontWeight: fonts.medium, fontSize: 13, color: colors.onErrorSurface }}>{error}</Text>
          </View>
        ) : null}
      </View>
      <View style={{ padding: "8px 20px 20px", backgroundColor: colors.surface, position: "sticky", bottom: 0 }}>
        <Button testID="login-submit-button" title={tr("signIn")} onPress={submit} loading={loading} iconRight="arrow-right" />
      </View>
    </View>
  );
}
